var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_4402_22465",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#949494"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_4402_22465)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16699 15.8332H5.21824L13.7487 7.30275L12.6974 6.2515L4.16699 14.7819V15.8332ZM2.91699 17.0832V14.2628L13.9091 3.27546C14.035 3.16102 14.1741 3.07262 14.3264 3.01025C14.4787 2.94775 14.6385 2.9165 14.8055 2.9165C14.9726 2.9165 15.1344 2.94616 15.291 3.00546C15.4476 3.06477 15.5863 3.15907 15.707 3.28838L16.7247 4.3188C16.854 4.43949 16.9462 4.57838 17.0012 4.73546C17.0562 4.89255 17.0837 5.04963 17.0837 5.20671C17.0837 5.37435 17.055 5.53428 16.9978 5.6865C16.9406 5.83887 16.8496 5.97803 16.7247 6.104L5.73741 17.0832H2.91699ZM13.2139 6.7863L12.6974 6.2515L13.7487 7.30275L13.2139 6.7863Z",
    fill: "#949494"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/edit-icon.8b98cb5fa217027735946a2b911fd6d4.svg";
export { ForwardRef as ReactComponent };